var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAistar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.25693C0 9.65091 0.253469 10.0012 0.628296 10.1231L4.58962 11.4105L5.8759 15.3699C5.99725 15.7448 6.3478 15.9988 6.7415 15.9988C7.13521 15.9988 7.48575 15.745 7.6071 15.3699L8.89608 11.4105L12.8547 10.1231C13.2295 10.0012 13.483 9.65118 13.483 9.2572C13.483 8.86295 13.2295 8.5132 12.8547 8.39131L8.89608 7.10394L7.6071 3.14448C7.48575 2.76938 7.13521 2.51562 6.7415 2.51562C6.3478 2.51562 5.99725 2.76965 5.8759 3.14448L4.58962 7.10394L0.628296 8.39131C0.253469 8.5132 0 8.86268 0 9.25693Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7161 0.298139C13.6579 0.120378 13.4939 0 13.3062 0C13.1186 0 12.9546 0.120378 12.8963 0.298139L12.275 2.20541L10.368 2.82564C10.1911 2.88345 10.0703 3.04913 10.0703 3.23595C10.0703 3.42278 10.1911 3.58846 10.368 3.64627L12.275 4.2665L12.8963 6.17377C12.9546 6.35153 13.1186 6.47191 13.3062 6.47191C13.4939 6.47191 13.6579 6.35153 13.7161 6.17377L14.3374 4.2665L16.2444 3.64627C16.4213 3.58846 16.5422 3.42278 16.5422 3.23595C16.5422 3.04913 16.4213 2.88345 16.2444 2.82564L14.3374 2.20541L13.7161 0.298139Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAistar);
export default __webpack_public_path__ + "static/media/Aistar.1f4942f12d91493f2f10422d56487731.svg";
export { ForwardRef as ReactComponent };